import React, {useState, useEffect, useContext} from 'react';
import {useTranslation} from "react-i18next";
import PageTitle from "../../components/Commons/PageTitle";
import BudgetForm from "../../components/Budget/BudgetForm";
import Helpbox from "../../components/UI/Helpboxes/Helpbox";
import Spinner from "../../components/UI/Spinner";

import Helpboxes from "../../components/UI/Helpboxes/Helpbox";
import axios from "../../axios-defaults";
import ModalMxo from "../../components/UI/Modal";
import {Link} from "react-router-dom";
import Notice24H from "../../components/Accounts/Account/Summary/Modals/Notice24h";
import {toast} from "react-toastify";
import { useLocation } from "react-router-dom";
import Alert from "../../components/UI/Alerts/Alert";
const Budget = (props) => {
    const {t, i18n} = useTranslation();
    const [docusignDocument, setDocusignDocument] = useState({})
    const [docusignCompleted, setDocusignCompleted] = useState(false)
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
	const location = useLocation();
	const queryParameters = new URLSearchParams(location.search);

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const submitDocusignSuccess = () => {
        const queryParameters = new URLSearchParams(window.location.search);
        const event = queryParameters.get('event');
        if (event !== null) {

            const documentId = queryParameters.get('document_id');
            const envelopeId = queryParameters.get('envelope_id');
			const paymentType = queryParameters.get('payment_type');
			const storedPaymentType = localStorage.getItem('paymentType');
			const hasPreAuthorizedAccount = localStorage.getItem('hasPreAuthorizedAccount') === 'true';

			let titleKey;

			if (hasPreAuthorizedAccount) {
				titleKey = `budget.post.edit.title`; //`budget.post.${storedPaymentType}.title_edit`;
			} else {
				titleKey = `budget.post.${storedPaymentType}.title`;
			}


            if (event === 'signing_complete' && documentId !== null && envelopeId !== null) {
                setLoading(true);
                axios.post(`/dataverse/incidents/create`, {
					title: t(titleKey),
                    document_id: documentId,
                    envelope_id: envelopeId,
					payment_type: storedPaymentType
                }).then(response => {
                    if (response.data.succeeded) {
                        setShowModal(true);
                        setDocusignCompleted(true);
                    } else {
                        toast.error(
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp; {response.data.message}
                            </div>
                        );
                    }
                    setLoading(false);
                }).catch(error => {
                    console.log(response.data.message);
                    console.log('[Budget.js] : Ajax error in submitDocusignSuccess()', error.message)
                    setLoading(false);
                });
            } else {
				if(event !== "cancel" && event !== "decline"){
					toast.error(
						<div>
							<i className="fal fa-exclamation-circle"></i>&nbsp; {t("popuporderstatus.cancel.error")}
						</div>
					);
				}
            }
        }
    }

    useEffect(async () => {
        await submitDocusignSuccess()
    }, [])

	const handlePaymentTypeSubmit = (paymentType) => {
		setPaymentType(paymentType);
	}

	let showMessageReturn = "";
	let paramValueEvent = queryParameters.get("event");
	if(paramValueEvent !== undefined && paramValueEvent !== null){
		if(paramValueEvent === "cancel" || paramValueEvent === "decline"){
			showMessageReturn = <Alert type="info" item={{
				type: 'info',
				additionalClasses: 'message mb-4',
				customIcon: 'fas fa-exclamation-circle',
				text: `budget.return`
			}}/>;
		}
	}
    return (
        <React.Fragment>
            <div className="container container--larger budget">
                <PageTitle title={t('breadcrumbs.budget')}/>
                <br/>
                <div className="accordions">
					{showMessageReturn}

					<div>
						{loading ? <Spinner/> : <BudgetForm onSubmit={handlePaymentTypeSubmit}/>}
					</div>

                </div>
                <div className="mt-4">
                    <Helpbox cta={true} />
                </div>
            </div>

            <ModalMxo title={t('budget.modal.title')}
                  show={showModal}
                  hideFooter={false}
                  footerActions={false}
                  backDrop='static'
                  closeButtonClass={'btn btn--outline btn--outline--lightgray'}
                  closeButtonText={t('budget.modal.button')}
                  onHide={handleCloseModal}
                  onShow={handleShowModal}>
                <div>
                    <h3 className="headline headline--c-red h3">{t('budget.modal.headline')}</h3>
                    <p>{t('budget.modal.text')}</p>
                    <Notice24H text={t('budget.modal.notice')}/>
                </div>
            </ModalMxo>
        </React.Fragment>
    )
}

export default Budget;

